import { useLayoutEffect, type RefObject } from "react"

const POSITIONS = new Map<string, number>()

export const usePageScrollRestoration = (
  ref: RefObject<HTMLElement | null>,
  key: string,
) => {
  useLayoutEffect(() => {
    const element = ref.current
    if (!element) return
    const restore = () => {
      element.scrollTop = POSITIONS.get(key) || 0
    }
    restore()
    const frame = requestAnimationFrame(restore)
    return () => {
      cancelAnimationFrame(frame)
      POSITIONS.set(key, element.scrollTop)
      if (POSITIONS.size > 30) {
        const oldest = POSITIONS.keys().next().value
        if (oldest) POSITIONS.delete(oldest)
      }
    }
  }, [ref, key])
}
